import { useCallback, useEffect, useState } from "react";
import { useReadCompensations } from "../supabase/crud-helpers/compensations";
import { useLocation } from "react-router-dom";
import { supabase } from "../supabase/supabase";
import { useActiveSession } from "../supabase/session";
import { useToast } from "@/components/ui/use-toast";

export function useBackgroundActionUpdateStatus() {
  const location = useLocation();
  const { data, error } = useReadCompensations();
  const user = useActiveSession();
  const { toast } = useToast();

  const [isWorking, setIsWorking] = useState(false);

  const queryParamsSessionId = new URLSearchParams(location.search).get(
    "session_id"
  );
  const compensationId = new URLSearchParams(location.search).get(
    "compensation_id"
  );

  const compensation = data?.find((c) => c.id === compensationId);

  const updateStatus = useCallback(async () => {
    if (
      compensationId &&
      compensation?.status === "signed" &&
      location.search.includes("status=success") &&
      queryParamsSessionId
    ) {
      setIsWorking(true);
      toast({
        title: "Sprawdzamy płatność",
        description: "Nie odświeżaj strony...",
      });
      await supabase.functions
        .invoke(
          `fullfilment?session_id=${queryParamsSessionId}&compensation_id=${compensationId}`,
          {
            method: "POST",
          }
        )
        .then(() => {
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          console.error("Failed to send email", error);
        })
        .finally(() => {
          setIsWorking(false);
        });
    }

    if (
      compensationId &&
      compensation?.status === "payment_completed" &&
      location.search.includes("status=success") &&
      queryParamsSessionId
    ) {
      if (!isWorking) {
        setIsWorking(true);
      }
      console.log("Sending email");
      toast({
        title: "Trwa wysyłka zgłoszenia",
        description: "Nie odświeżaj strony...",
      });
      await supabase.functions
        .invoke(
          `mailing?compensation_id=${compensationId}&email=${user?.session?.user.email}`,
          {
            method: "POST",
          }
        )
        .then(() => {
          window.location.href = "/finalized";
        })
        .catch((error) => {
          console.error("Failed to send email", error);
        })
        .finally(() => {
          setIsWorking(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    compensationId,
    location.search,
    queryParamsSessionId,
    isWorking,
    compensation?.status,
  ]);

  useEffect(() => {
    updateStatus();
    console.log("Updating status");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    compensation?.status,
    compensationId,
    location.search,
    queryParamsSessionId,
  ]);

  return { data, error, isWorking };
}
